import classnames from 'classnames';
import { FC, RefAttributes, SVGProps } from 'react';

import styles from './header.module.scss';
import { HeaderProps, HeaderType } from './header.types';

export const Header =
  (HeaderElement: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>): HeaderType =>
  ({ className, ...props }: HeaderProps) => {
    return <HeaderElement className={classnames(styles.header, className)} {...props} />;
  };
